export const siteConfig = {
  siteName: "爱情岛论坛",
  siteTagline: "高清视频在线观看，情感交流社区",
  siteDescription: "爱情岛论坛在线观看最新内容，提供高清免费视频播放入口，无需下载，随时随地流畅观看。汇聚爱情岛论坛在线观看的最新资源，支持多线路切换，让您享受极致观看体验。",
  siteKeywords: "爱情岛论坛在线观看,爱情岛论坛免费观看,爱情岛在线高清视频,爱情岛论坛最新地址,爱情岛视频在线播放,爱情岛论坛入口,免费高清视频在线观看",
  siteUrl: "https://junjiuhan.cn",
  logo: "爱情岛",
  contactEmail: "contact@aiqingdao.com",
  contactPhone: "400-888-6666",
  address: "北京市朝阳区建国路88号爱情岛大厦",
  wechat: "aiqingdao_official",
  weibo: "@爱情岛论坛",
};

export const navigationLinks = [
  { label: "首页", href: "/" },
  { label: "恋爱技巧", href: "/category/dating-tips" },
  { label: "情感故事", href: "/category/love-stories" },
  { label: "婚姻经营", href: "/category/marriage" },
  { label: "心理学堂", href: "/category/psychology" },
  { label: "热门综艺", href: "/category/hot-shows" },
  { label: "关于我们", href: "/about" },
];

export const categories = [
  {
    slug: "dating-tips",
    name: "恋爱技巧",
    icon: "ri-heart-line",
    description: "实用的恋爱技巧与约会指南，助你收获甜蜜爱情",
    color: "from-rose-400 to-pink-500",
    count: 128,
  },
  {
    slug: "love-stories",
    name: "情感故事",
    icon: "ri-book-open-line",
    description: "真实动人的爱情故事，感受人间真情",
    color: "from-amber-400 to-orange-500",
    count: 96,
  },
  {
    slug: "marriage",
    name: "婚姻经营",
    icon: "ri-home-heart-line",
    description: "婚姻保鲜秘诀，家庭幸福之道",
    color: "from-emerald-400 to-teal-500",
    count: 85,
  },
  {
    slug: "psychology",
    name: "心理学堂",
    icon: "ri-brain-line",
    description: "从心理学角度解读爱情，了解两性心理",
    color: "from-violet-400 to-purple-500",
    count: 74,
  },
  {
    slug: "relationships",
    name: "两性话题",
    icon: "ri-user-heart-line",
    description: "两性关系深度探讨，促进相互理解",
    color: "from-cyan-400 to-blue-500",
    count: 63,
  },
  {
    slug: "hot-shows",
    name: "热门综艺",
    icon: "ri-tv-line",
    description: "热门情感综艺节目，精彩不容错过",
    color: "from-red-400 to-rose-500",
    count: 112,
  },
];

export const featuredVideos = [
  {
    id: 1,
    title: "第一次约会必知的10个小技巧",
    category: "dating-tips",
    categoryName: "恋爱技巧",
    thumbnail: "https://readdy.ai/api/search-image?query=A%20romantic%20coffee%20shop%20date%20scene%20with%20a%20couple%20sitting%20at%20a%20wooden%20table%20near%20a%20large%20window%2C%20soft%20warm%20lighting%2C%20two%20coffee%20cups%2C%20comfortable%20atmosphere%2C%20clean%20minimalist%20background%2C%20editorial%20photography%20style&width=800&height=450&seq=video-thumb-01&orientation=landscape",
    duration: "12:38",
    views: 125800,
    date: "2026-08-05",
    description: "第一次约会总是让人既期待又紧张。本期视频为你准备了10个实用小技巧，从见面问候到告别细节，帮你轻松应对约会中的各种场景。",
    tags: ["约会技巧", "恋爱入门", "社交指南"],
    author: "情感导师小艾",
  },
  {
    id: 2,
    title: "异地恋如何维持感情的秘诀",
    category: "love-stories",
    categoryName: "情感故事",
    thumbnail: "https://readdy.ai/api/search-image?query=A%20couple%20video%20calling%20on%20a%20laptop%20screen%2C%20warm%20cozy%20bedroom%20setting%20with%20fairy%20lights%2C%20distance%20love%20concept%2C%20soft%20evening%20light%2C%20emotional%20connection%20theme%2C%20clean%20minimalist%20style&width=800&height=450&seq=video-thumb-02&orientation=landscape",
    duration: "18:25",
    views: 98300,
    date: "2026-08-03",
    description: "异地恋真的那么难吗？本期我们采访了三对成功走过异地恋的情侣，听听他们分享的独家秘诀和感人故事。",
    tags: ["异地恋", "情感维系", "真实故事"],
    author: "故事收集者小鹿",
  },
  {
    id: 3,
    title: "婚姻七年之痒的破解之道",
    category: "marriage",
    categoryName: "婚姻经营",
    thumbnail: "https://readdy.ai/api/search-image?query=A%20happy%20middle-aged%20couple%20walking%20hand%20in%20hand%20in%20a%20beautiful%20autumn%20park%2C%20golden%20leaves%20falling%2C%20genuine%20smiles%2C%20long-term%20relationship%20theme%2C%20warm%20natural%20lighting%2C%20cinematic%20photography&width=800&height=450&seq=video-thumb-03&orientation=landscape",
    duration: "22:10",
    views: 87600,
    date: "2026-08-01",
    description: "结婚七年，激情褪去后如何保持婚姻的温度？资深婚姻咨询师为你剖析七年之痒的真相与破解方法。",
    tags: ["婚姻", "七年之痒", "夫妻关系"],
    author: "婚姻咨询师李老师",
  },
  {
    id: 4,
    title: "从心理学看为什么你总是吸引错的人",
    category: "psychology",
    categoryName: "心理学堂",
    thumbnail: "https://readdy.ai/api/search-image?query=A%20thoughtful%20person%20looking%20at%20their%20reflection%20in%20a%20large%20modern%20mirror%2C%20self%20discovery%20concept%2C%20minimalist%20bright%20interior%20with%20plants%2C%20psychological%20introspection%20theme%2C%20soft%20natural%20daylight%2C%20clean%20aesthetic&width=800&height=450&seq=video-thumb-04&orientation=landscape",
    duration: "15:42",
    views: 112400,
    date: "2026-07-30",
    description: "你是否发现自己总是被同一类型的人吸引，却又总是以失败告终？本期从依恋理论出发，帮你认识自己的情感模式。",
    tags: ["心理学", "依恋理论", "自我认知"],
    author: "心理学博士王教授",
  },
];

export const latestContent = [
  {
    id: 5,
    title: "相亲时应该问的15个关键问题",
    category: "dating-tips",
    categoryName: "恋爱技巧",
    thumbnail: "https://readdy.ai/api/search-image?query=A%20blind%20date%20scene%20at%20a%20modern%20restaurant%2C%20two%20people%20having%20a%20pleasant%20conversation%2C%20elegant%20table%20setting%2C%20warm%20ambient%20lighting%2C%20genuine%20expressions%2C%20editorial%20style%20photography%2C%20clean%20background&width=800&height=450&seq=video-thumb-05&orientation=landscape",
    duration: "14:20",
    views: 56200,
    date: "2026-08-06",
    author: "情感导师小艾",
  },
  {
    id: 6,
    title: "那些年我们追过的校园爱情",
    category: "love-stories",
    categoryName: "情感故事",
    thumbnail: "https://readdy.ai/api/search-image?query=A%20beautiful%20university%20campus%20with%20cherry%20blossom%20trees%2C%20young%20couple%20sitting%20on%20a%20bench%20reading%20books%2C%20nostalgic%20youthful%20love%20theme%2C%20soft%20spring%20sunlight%2C%20clean%20cinematic%20aesthetic&width=800&height=450&seq=video-thumb-06&orientation=landscape",
    duration: "20:15",
    views: 78900,
    date: "2026-08-05",
    author: "故事收集者小鹿",
  },
  {
    id: 10,
    title: "夫妻吵架后如何快速和好",
    category: "marriage",
    categoryName: "婚姻经营",
    thumbnail: "https://readdy.ai/api/search-image?query=A%20couple%20making%20up%20after%20an%20argument%2C%20holding%20hands%20across%20a%20wooden%20table%2C%20warm%20home%20interior%2C%20candle%20light%2C%20reconciliation%20and%20forgiveness%20theme%2C%20soft%20emotional%20lighting%2C%20intimate%20atmosphere&width=800&height=450&seq=video-thumb-07&orientation=landscape",
    duration: "11:30",
    views: 67800,
    date: "2026-08-04",
    author: "婚姻咨询师李老师",
  },
  {
    id: 7,
    title: "MBTI性格类型与恋爱匹配度解析",
    category: "psychology",
    categoryName: "心理学堂",
    thumbnail: "https://readdy.ai/api/search-image?width=800&height=450&seq=video-thumb-08&orientation=landscape&query=Colorful%20personality%20type%20concept%20illustration%20with%20abstract%20geometric%20shapes%2C%16%20personality%20types%20visualization%2C%20modern%20flat%20design%2C%20vibrant%20yet%20soft%20colors%2C%20relationship%20compatibility%20theme%2C%20clean%20minimalist%20background",
    duration: "19:50",
    views: 94200,
    date: "2026-08-03",
    author: "心理学博士王教授",
  },
  {
    id: 8,
    title: "男女思维差异到底有多大",
    category: "relationships",
    categoryName: "两性话题",
    thumbnail: "https://readdy.ai/api/search-image?query=Two%20silhouettes%20facing%20each%20other%20with%20puzzle%20pieces%20floating%20between%20them%2C%20gender%20communication%20concept%2C%20modern%20minimalist%20design%2C%20soft%20gradient%20background%2C%20understanding%20differences%20theme%2C%20clean%20editorial%20style&width=800&height=450&seq=video-thumb-09&orientation=landscape",
    duration: "16:05",
    views: 135600,
    date: "2026-08-02",
    author: "两性关系专家陈老师",
  },
  {
    id: 9,
    title: "《心动的信号》第六季精彩回顾",
    category: "hot-shows",
    categoryName: "热门综艺",
    thumbnail: "https://readdy.ai/api/search-image?query=A%20romantic%20reality%20TV%20show%20set%20with%20beautiful%20villa%20and%20garden%2C%20young%20singles%20mingling%2C%20dating%20show%20concept%2C%20warm%20sunset%20lighting%2C%20entertainment%20production%20style%2C%20colorful%20and%20lively%20atmosphere&width=800&height=450&seq=video-thumb-10&orientation=landscape",
    duration: "25:30",
    views: 189000,
    date: "2026-08-01",
    author: "综艺观察员小美",
  },
];

export const trendingContent = [
  { id: 1, title: "第一次约会必知的10个小技巧", views: 125800, category: "恋爱技巧" },
  { id: 7, title: "男女思维差异到底有多大", views: 135600, category: "两性话题" },
  { id: 9, title: "《心动的信号》第六季精彩回顾", views: 189000, category: "热门综艺" },
  { id: 4, title: "从心理学看为什么你总是吸引错的人", views: 112400, category: "心理学堂" },
  { id: 7, title: "MBTI性格类型与恋爱匹配度解析", views: 94200, category: "心理学堂" },
  { id: 2, title: "异地恋如何维持感情的秘诀", views: 98300, category: "情感故事" },
  { id: 3, title: "婚姻七年之痒的破解之道", views: 87600, category: "婚姻经营" },
  { id: 6, title: "那些年我们追过的校园爱情", views: 78900, category: "情感故事" },
];

export const faqItems = [
  {
    question: "爱情岛论坛是什么？",
    answer: "爱情岛论坛是一个专注于情感交流与视频内容的综合社区平台。我们提供高清视频在线观看服务，涵盖恋爱技巧、情感故事、婚姻经营、心理学堂等多个板块，让用户随时随地流畅观看精彩内容。",
  },
  {
    question: "爱情岛论坛的视频需要下载吗？",
    answer: "完全不需要！爱情岛论坛的所有视频均支持在线高清播放。只需打开网页即可流畅观看，无需下载任何播放器或视频文件，节省您的手机存储空间。",
  },
  {
    question: "爱情岛论坛支持哪些设备观看？",
    answer: "爱情岛论坛完美适配电脑、平板和手机等各种设备。无论您使用Windows、Mac、iOS还是Android系统，都可以通过浏览器直接访问，获得一致的流畅观看体验。",
  },
  {
    question: "爱情岛论坛的视频内容是免费的吗？",
    answer: "是的，爱情岛论坛的所有视频内容均免费向用户开放。我们致力于打造开放、共享的情感知识平台，让每个人都能轻松获取高质量的恋爱和情感内容。",
  },
  {
    question: "如何找到爱情岛论坛的最新内容？",
    answer: "您可以收藏本网站首页，我们会每日更新最新内容。首页的「最新更新」板块汇集了最近发布的所有视频和文章，确保您不会错过任何精彩内容。",
  },
  {
    question: "爱情岛论坛可以切换播放线路吗？",
    answer: "当然可以！爱情岛论坛支持多线路切换功能。如果您在观看视频时遇到卡顿，可以点击播放器下方的线路切换按钮，选择更流畅的播放线路，确保最佳观看体验。",
  },
];

export const aboutInfo = {
  brandIntro: {
    title: "关于爱情岛论坛",
    content: [
      "爱情岛论坛成立于2020年，是国内领先的情感交流与视频内容综合平台。我们致力于为广大用户提供高质量的情感类视频内容，涵盖恋爱技巧、婚姻经营、心理学知识、两性话题等多个领域。",
      "平台汇聚了众多资深情感导师、婚姻咨询师和心理学专家，通过视频、文章、直播等多种形式，为用户传递专业、实用、温暖的情感知识和生活智慧。",
      "自成立以来，爱情岛论坛已累计服务超过500万用户，日均视频播放量突破100万次，成为国内最具影响力的情感类内容平台之一。",
    ],
    stats: [
      { value: "500万+", label: "累计用户" },
      { value: "100万+", label: "日均播放" },
      { value: "50+", label: "合作专家" },
      { value: "3000+", label: "视频内容" },
    ],
  },
  reputation: {
    title: "平台信誉",
    items: [
      { icon: "ri-shield-check-line", title: "内容审核严格", description: "所有视频内容均经过专业团队审核，确保内容质量和信息准确性，为用户提供安全可靠的内容环境。" },
      { icon: "ri-user-star-line", title: "用户好评如潮", description: "平台累计获得超过50万条用户好评，用户满意度高达98.6%，是值得信赖的情感内容平台。" },
      { icon: "ri-award-line", title: "行业认可", description: "荣获2025年度中国互联网情感社区创新奖、最佳用户体验平台等多项行业荣誉。" },
      { icon: "ri-lock-line", title: "隐私保护", description: "严格保护用户隐私，采用多重加密技术，确保用户信息安全，让您放心使用。" },
    ],
  },
  contact: {
    title: "联系我们",
    description: "如果您有任何问题、建议或合作意向，欢迎通过以下方式与我们取得联系。我们的客服团队将在24小时内回复您的消息。",
    email: "contact@aiqingdao.com",
    phone: "400-888-6666",
    address: "北京市朝阳区建国路88号爱情岛大厦",
    wechat: "aiqingdao_official",
    weibo: "@爱情岛论坛",
    workingHours: "周一至周日 9:00 - 21:00",
  },
};